import { Component, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthStore } from '../store/auth.store';


@Component({
  selector: 'app-auth-form',
  templateUrl: './auth-form.page.html',
  styleUrls: ['./auth-form.page.scss'],
})
export class AuthFormPage implements OnInit {

  constructor(
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private authStore: AuthStore,
  ) { }

  ngOnInit() {
  }

  authView = 'login';

  authUser = {
    fname: '',
    lname: '',
    email: '',
    password: '',
  }


  close() {
    this.modalCtrl.dismiss();
  }


  forgotPassword(email) {
    this.authStore.forgotPassword(email)
      .then(() => {
        this.alertCtrl.create({
          header: "Email Sent",
          message: "A password reset email has been sent to you",
          buttons: ["Ok"]
        }).then(a => a.present())
      })
  }


  login() {
    console.log('clicked')
    this.authStore.login(this.authUser.email, this.authUser.password)
      .then(() => {
        this.modalCtrl.dismiss()
      }).catch((error) => {
        this.problemAlert(error)
      })
  }

  register() {
    console.log(this.authUser)
    this.authStore.createUser(this.authUser.fname, this.authUser.lname, this.authUser.password, this.authUser.email)
      .then(() => {
        this.modalCtrl.dismiss();
      }).catch((error) => {
        this.problemAlert(error)
      })
  }

  problemAlert(error) {
    this.alertCtrl.create(
      {
        header: "There was a problem",
        message: error.message,
        buttons: ['Ok']
      }
    ).then(a => a.present())
  }
}
